/** Keep `value` tokens in sync with `studio/src/constants/richTextBrandColors.ts` (and globals.css). */
export const RICH_TEXT_BRAND_COLOR_TOKENS = [
  "black",
  "white",
  "primary",
  "primary-100",
  "primary-200",
  "primary-400",
  "adt-brand-blue",
  "secondary",
  "secondary-100",
  "secondary-300",
  "greyscale-background",
  "greyscale-strength",
  "greyscale-body",
  "greyscale-headline",
  "success",
  "error",
  "adt-amber",
] as const;

export type RichTextBrandColorToken =
  (typeof RICH_TEXT_BRAND_COLOR_TOKENS)[number];

const TOKENS = RICH_TEXT_BRAND_COLOR_TOKENS as readonly string[];

export function isRichTextBrandColorToken(
  value: string | undefined,
): value is RichTextBrandColorToken {
  return value !== undefined && TOKENS.includes(value);
}
